import { useNavigate, useParams } from 'react-router-dom'
import { useStateValue } from 'providers'
import { apiFetch } from 'actions/apiFetch'
import { useGetQuery, usePostQuery } from 'hooks'
import { Card, Title } from 'components'
import { EventForm } from './form'

export const EventEdit = () => {
  const [{ session: { user } }] = useStateValue()
  const { id } = useParams()
  const navigate = useNavigate()

  const isHost = ['host:owner', 'host:manager'].includes(user?.roles?.[0]?.slug)

  const { data: eventData } = useGetQuery({ url: `/events/${id}` })
  const { data: hostData } = useGetQuery({ enabled: isHost, url: '/host/places' })
  const { post: updateEvent } = usePostQuery({ url: `/events/${id}`, method: 'PUT' })

  const hostPlaces = isHost ? (hostData?.locations?.rows ?? null) : []
  const searchPlaces = isHost ? null : (q) => apiFetch({ path: `/locations?q=${encodeURIComponent(q)}` })

  const handleSubmit = async (payload) => {
    await updateEvent(payload)
    navigate(`/events/${id}`)
  }

  const event = eventData?.event
  if (!event) return null
  if (isHost && hostPlaces === null) return null

  return (
    <Card>
      <Title level={2}>Edit Event</Title>
      <EventForm
        initial={event}
        onSubmit={handleSubmit}
        submitLabel="Save Changes"
        searchPlaces={searchPlaces}
        places={hostPlaces}
      />
    </Card>
  )
}
